export default __webpack_public_path__ + "static/media/watch-connected.39e11fe4.svg";